module.exports = __webpack_public_path__ + "img/imiwin-support.3a941ffd.png";